<template>
  <v-form ref="form" lazy-validation class="pa-3" @submit.prevent="createBrand">
    <div class="d-flex justify-end">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'brand-index' })"
      >
        <v-icon left>
          arrow_back
        </v-icon>
        Back
      </v-btn>
    </div>
    <v-row>
      <v-col offset-lg="4" cols="4">
        <div class="text-center">
          <v-text-field
            :rules="nameRules"
            label="Name"
            v-model="brand.name"
            required
          ></v-text-field>

          <image-picker
            v-model="brand.logo"
            :uploaded="brand.logo !== null"
            @delete-item="brand.logo = null"
            @reset="brand.logo = null"
            class="mb-5"
          >
            <div slot="activator" class="cursor-pointer">
              <img
                :src="brand.logo"
                alt="avatar"
                width="312px"
                height="312px"
                v-if="brand.logo"
              />
            </div>
          </image-picker>
          <v-btn type="submit" class="mx-0 mt-4">Create</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import ImagePicker from "@/components/ImagePicker.vue";
export default {
  data() {
    return {
      brand: {
        name: null,
        logo: null
      },
      rules: [
        value =>
          !value ||
          value.size < 2000000 ||
          "Avatar size should be less than 2 MB!"
      ],
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length >= 5) || "Name must be at least 5 characters",
        v =>
          (v && v.length <= 35) || "Name must be less than than 35 characters"
      ]
    };
  },
  components: {
    ImagePicker
  },
  methods: {
    loadLogo(event) {
      this.brand.logo = event.target.files[0];
    },
    async createBrand() {
      let formdata = new FormData();
      formdata.append("name", this.brand.name);
      formdata.append("logo", this.brand.logo);
      this.$swal({
        title: "Adding product brand...",
        html: "this will only take a moment...",
        icon: "info",
        didOpen: () => {
          this.$swal.showLoading();
        }
      });
      await this.$store.dispatch("brands/CREATE_BRAND", formdata);
      this.$swal.close();
      this.$swal({
        title: "Success",
        html: "Product brand has been added",
        icon: "success"
      });
    }
  }
};
</script>
